import {createSlice} from '@reduxjs/toolkit';

export interface MyProfileModalInterface {
  open: boolean
}

// Stateの初期状態
const initialState: MyProfileModalInterface = {
  open: false,
};

// Sliceを生成する
const slice = createSlice({
  name    : 'my-profile-modal',
  initialState,
  reducers: {
    open : (state) => {
      return {...state, open: true};
    },
    close: (state) => {
      return {...state, open: false};
    },
  }
});

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const {open, close} = slice.actions;
